import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { isNativeClient } from 'Environment/launchResource/device';
import { isAppProtectEnabledByOnPremAdmin } from 'Workspace/AppContext/onpremAppProtectionUtils';

//https://issues.citrite.net/browse/WSUI-9963
export function canHaveEmptyResources(workspaceConfiguration: WorkspaceConfiguration) {
	return (
		IS_ON_PREM &&
		!isNativeClient() &&
		isAppProtectEnabledByOnPremAdmin(workspaceConfiguration)
	);
}
